import { i18n } from '@international/mastodon-i18n';

export const getDocumentOptions = () => [
  { enabled: true },
  { value: 'TaxFormW2', name: 'W-2', disabled: false },
  { value: 'TaxForm1099', name: '1099', disabled: false },
  { value: 'Paystub', name: 'Paystub', disabled: false },
  {
    value: 'TaxFormScheduleC',
    name: 'Schedule C (Form 1040)',
    disabled: false,
  },
  {
    value: 'EmploymentProof',
    name: i18n.getStr('components.Verification.EmploymentMultidocPanel.other'),
    disabled: false,
  },
];

export const selectYear = i18n.getStr(
  'components.Verification.EmploymentMultidocPanel.selectYear',
);
export const multiDocuments = 'multi_documents';
export const getSelectYearOption = () => [
  {
    value: selectYear,
    name: selectYear,
    uploadId: '',
    disabled: false,
  },
];
